import { useContext } from 'react'
import { UserContext } from '../../../../../context/UserContextProvider'

// Historia 148 — las authorities del perfil, leídas SIN los efectos de `useUser`.
//
// ⚠️ POR QUÉ NO `useAuthorization` AQUÍ, que es lo primero que uno escribiría: `useAuthorization`
// llama a `useUser`, y `useUser` hace dos cosas que no puede hacer un gate puramente presentacional
// montado en las CUATRO superficies de MOS a la vez:
//
//   1. **Lanza** (`useUser must be used within a UserProvider`) si no hay proveedor. El botón se
//      monta dentro de widgets que se prueban —y se renderizan— en aislamiento; un gate de pintado
//      no puede tumbar la pantalla del puesto porque falte un contexto.
//   2. Monta un `setInterval` de 1 segundo y, con el usuario aún sin resolver, dispara un
//      `fetch('token/isTokenValid')` **por consumidor**. Cuatro superficies de planta, cuatro
//      relojes, en una pantalla que ya sondea su contexto activo cada pocos segundos (R7).
//
// Lo que NO se duplica aquí es la REGLA: qué permiso hace falta y cuántos bastan vive en
// `fabricationDocumentSources.hasAnyDocumentViewPermission`, un único sitio. Esto es solo la
// lectura del conjunto de authorities, y `__tests__/useDocumentAuthorities.test.jsx` lo compara
// contra `useAuthorization` real para que las dos respuestas no puedan divergir.
//
// Sin proveedor el resultado es «ninguna authority», que es la respuesta fail-secure (PN1): sin
// permiso no se pinta el acceso.

/**
 * @returns {(permissionCode: string) => boolean} El mismo evaluador que devuelve `useAuthorization`
 */
const useDocumentAuthorities = () => {
  const userContext = useContext(UserContext)
  const permissions = userContext?.user?.profile?.permissions || []
  return (permissionCode) => permissions.some((permission) => permission.code === permissionCode)
}

export default useDocumentAuthorities
